import { useEffectReducer } from 'use-effect-reducer'
import { getPMOFEffectsMap } from './effects'
import { pmofStateReducer } from './reducer'
import { PMOFArgs, PMOFState } from './types'

export const usePMOFEffectReducer = (args: PMOFArgs) => {
  return useEffectReducer(
    pmofStateReducer,
    exec => {
      // Kick off processing only when required identifiers are present
      if (args.customerId && args.paymentMethodOnFileId) {
        exec({ type: 'processPaymentEffect' })
      }
      return { status: 'processing' } as PMOFState
    },
    getPMOFEffectsMap(args)
  )
}
